/**
 * The short code a player can quote back to us in an email or forum post.
 *
 * It is generated here, before the upload, so the id we show is exactly the
 * name the report is stored under and is also recorded inside the archive - no
 * chance of the player reading one id while the bucket holds another.
 *
 * Crockford's base32 alphabet: no I, L, O or U, so there is nothing to confuse
 * with 1/0 when someone reads a code off their screen and types it out.
 */

const Alphabet = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const ReportIdLength = 10; // 50 bits - collisions aren't a practical concern

function randomBytes(count: number): Uint8Array {
	const bytes = new Uint8Array(count);
	const crypto = (window as any).crypto ?? (window as any).msCrypto;
	if (crypto?.getRandomValues) {
		crypto.getRandomValues(bytes);
		return bytes;
	}
	// Math.random is a poor source, but an id we can show beats no report at all.
	for (let i = 0; i < count; i++) bytes[i] = Math.floor(Math.random() * 256);
	return bytes;
}

export function generateReportId(): string {
	const bytes = randomBytes(ReportIdLength);
	let id = '';
	// One character per byte, taking the low 5 bits - every value maps to a
	// character, so there is no modulo bias to worry about.
	for (let i = 0; i < ReportIdLength; i++) {
		id += Alphabet[bytes[i] & 31];
	}
	return id;
}

/** Groups the id for display so it's easier to read aloud or copy by hand. */
export function formatReportId(id: string): string {
	return id.replace(/(.{5})(?=.)/g, '$1-');
}
